var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreenCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5763_4744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 6C14.08 6 6 14.08 6 24C6 33.92 14.08 42 24 42C33.92 42 42 33.92 42 24C42 14.08 33.92 6 24 6ZM24 39.54C15.42 39.54 8.46 32.56 8.46 24C8.46 15.44 15.44 8.46 24 8.46C32.56 8.46 39.54 15.44 39.54 24C39.54 32.56 32.56 39.54 24 39.54Z",
    fill: "#34A353"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 24L22.2426 28.2426L30.727 19.7573",
    stroke: "#34A353",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5763_4744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenCircle);
export default __webpack_public_path__ + "static/media/checkGreenCircle.b90db9e64e9f3652bbd7515f8d1c0b54.svg";
export { ForwardRef as ReactComponent };